import type { LocationDescriptor } from 'history';
import type { MouseEventHandler, ReactNode } from 'react';

export interface JoinBuyerPageData {
  formComponent: ReactNode;
  joinLink: LocationDescriptor;
  statusText?: ReactNode;
  showPostSignup: boolean;
  onDismissMessageClick?: MouseEventHandler;
}

export interface JoinBuyerPageProps extends JoinBuyerPageData {}
